/*
  Vibe Product List — WonderSkull custom (not part of stock Shrine PRO).

  "Load more" for the section's See More controls. Every picked product is rendered, but
  those past "Products to show" start hidden (inline display:none + [data-cp-overflow]).
  Clicking either See More control — the carousel card or the grid button — reveals the
  next batch: "Cards per view" for the current breakpoint (desktop vs mobile), rounded to
  a whole number. Once nothing is left, both controls hide themselves.

  Self-contained: it only touches this section's own markup. The shared
  block-curated-products.js keeps owning the carousel arrows — after revealing we fire a
  resize event so its position-based end-detection recomputes for the new width.
*/
(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function batchSize(root) {
    var d = parseFloat(root.getAttribute('data-cp-step-desktop')) || 4;
    var m = parseFloat(root.getAttribute('data-cp-step-mobile')) || 2;
    return Math.max(1, Math.round(MOBILE.matches ? m : d));
  }

  function hiddenItems(root) {
    return root.querySelectorAll('.curated-products__item[data-cp-overflow]');
  }

  // The two See More controls hide once nothing is left; while products remain, clearing
  // the inline display lets the per-breakpoint CSS keep choosing card vs button.
  function updateControls(root) {
    var remaining = hiddenItems(root).length;
    root.querySelectorAll('[data-cp-load-more]').forEach(function (btn) {
      var host =
        btn.closest('.curated-products__item--see-more') ||
        btn.closest('.curated-products__see-more-below-wrap') ||
        btn;
      host.style.display = remaining > 0 ? '' : 'none';
    });
  }

  function loadMore(root) {
    var items = hiddenItems(root);
    var n = batchSize(root);
    var last = null;
    for (var i = 0; i < items.length && i < n; i++) {
      items[i].style.display = '';
      items[i].removeAttribute('data-cp-overflow');
      last = items[i];
    }
    updateControls(root);

    // Nudge the shared carousel script to recompute arrow at-start/at-end for the new width.
    window.dispatchEvent(new Event('resize'));

    // Carousel: bring the newly revealed cards into view.
    var list = root.querySelector('.curated-products__list');
    if (last && list && list.scrollWidth > list.clientWidth) {
      last.scrollIntoView({
        inline: 'end',
        block: 'nearest',
        behavior: REDUCED_MOTION.matches ? 'auto' : 'smooth'
      });
    }
  }

  function init(root) {
    if (root.dataset.cpLoadMoreReady === 'true') return;
    root.dataset.cpLoadMoreReady = 'true';

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-cp-load-more]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      loadMore(root);
    });

    updateControls(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.curated-products--vibe-product-list').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
